export const TABS = { ALL: "ALL", TO_COVER: "TO_COVER", COVERED: "COVERED" };
